export const IconLinkedIn20: {
  name: 'icon_linked_in_20-8cdb6c13fbb5'
} = {
  name: 'icon_linked_in_20-8cdb6c13fbb5'
}
